import { render, staticRenderFns } from "./moneyBoxCreateModal.vue?vue&type=template&id=61d2e58e&"
import script from "./moneyBoxCreateModal.vue?vue&type=script&lang=ts&"
export * from "./moneyBoxCreateModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports